module.exports = __webpack_public_path__ + "static/media/icon-camera.8d4ddb2c.svg";